var _excluded = ["actions", "caption", "onClick", "src", "uploading"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import CircularProgress from './CircularProgress';
import Media from './Media';
import StyledGalleryImage, { StyledGalleryImageOverlay, StyledGalleryImageText } from './GalleryImage.styled';
var GalleryImage = forwardRef(function (_ref, ref) {
  var actions = _ref.actions,
    caption = _ref.caption,
    onClick = _ref.onClick,
    src = _ref.src,
    uploading = _ref.uploading,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/React.createElement(StyledGalleryImage, _extends({
    ref: ref
  }, rest), /*#__PURE__*/React.createElement(Media, {
    src: src
  }), uploading && /*#__PURE__*/React.createElement(StyledGalleryImageOverlay, {
    visible: true
  }, /*#__PURE__*/React.createElement(CircularProgress, {
    color: "inherit",
    size: 40
  })), !uploading && (onClick || actions) && /*#__PURE__*/React.createElement(StyledGalleryImageOverlay, {
    onClick: onClick
  }, actions, onClick && /*#__PURE__*/React.createElement(ZoomInIcon, {
    fontSize: "inherit"
  })), !uploading && caption && /*#__PURE__*/React.createElement(StyledGalleryImageText, null, caption));
});
GalleryImage.propTypes = {
  actions: PropTypes.node,
  caption: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onClick: PropTypes.func,
  src: PropTypes.string.isRequired,
  uploading: PropTypes.bool
};
GalleryImage.defaultProps = {
  actions: undefined,
  caption: undefined,
  onClick: undefined,
  uploading: false
};
export default GalleryImage;